import routes from "@/lib/routes";
import { ButtonLink } from "@/components/Buttons/index";
import { useMemo } from "react";

export default function ContractButtonLink({ course, right, ...props }) {
  const contractAllowed = course?.contractAllowed || right?.contractAllowed;
  const [text, color] = useMemo(() => {
    if (contractAllowed) {
      return ["購入する", { fillColor: true }];
    } else {
      return ["販売期間外", { fillGray: true }];
    }
  }, [contractAllowed]);

  const href = useMemo(() => {
    if (course) {
      return routes.svodPaymentStep(course.id, 1);
    } else if (right) {
      return routes.subscriptionByRight(right.id);
    }
  }, [course, right]);

  if (!href) return null;

  return (
    <ButtonLink href={href} disabled={!contractAllowed} {...color} {...props}>
      {text}
    </ButtonLink>
  );
}
